<template>
  <div class="output">
    <h4 v-if="result==undefined || (uploadPercent && uploadPercent < 100) || (downloadPercent && downloadPercent < 100)">
      <span v-if="uploadPercent && uploadPercent < 100">
        {{$t('message.uploading')}}
        <b-progress :max="100" height="1.5rem">
          <b-progress-bar :value="uploadPercent" :label="uploadPercent + '%'" class="progress-bar">
            <span><strong>{{ uploadPercent }}%</strong></span>
          </b-progress-bar>
        </b-progress>
      </span>
      <span v-else-if="downloadPercent && downloadPercent < 100">
        {{$t('message.downloading')}}
        <b-progress :max="100" height="1.5rem">
          <b-progress-bar :value="downloadPercent" :label="downloadPercent + '%'" class="progress-bar">
            <span><strong>{{ downloadPercent }}%</strong></span>
          </b-progress-bar>
        </b-progress>
      </span>
      <span v-else>{{$t('message.result_in_progress')}} </span>
    </h4>

    <h4 v-else-if="result" class="output-success">
      {{$t('message.result_success')}}
      <b-button type="button" v-if="output && !showOutput" @click="showOutput=true">
        {{$t('message.button_show_output') | title}}
      </b-button>
    </h4>

    <h4 v-else class="output-failure">
      <span>{{$t('message.result_failure')}}</span>
      <span v-if="errorMessage"> - {{errorMessage}}</span>
    </h4>
    <b-form-textarea name="output" v-if="outputDisplay && showOutput" v-model="outputDisplay" disabled max-rows="20"/>

    <b-button type="button" v-if="outputDisplay && showOutput" class="padmin-button"
      id="copyButton" @click="copyToClipboard">
      {{$t('message.button_copy_to_clipboard') | title}}
    </b-button>
  </div>
</template>

<script>
export default {
  name: "ConsoleOutput",

  props: {
    output: String,
    result: Boolean,
    errorCode: Number,
    uploadPercent: Number,
    downloadPercent: Number
  },

  data () {
    return {showOutput: true}
  },

  computed: {
    errorMessage() {
      if (!this.errorCode) {
        return ''
      }
      let messageLookup = 'message.error_code_' + this.errorCode
      let errorMess = this.$t(messageLookup)
      if (errorMess === messageLookup) {
        return 'error code ' + this.errorCode
      }
      return errorMess
    },

    outputDisplay() {
      return this.output.trim()
    }
  },

  methods: {
    copyToClipboard() {
      var textArea = document.createElement("textarea")
      textArea.value = this.output
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      document.execCommand("copy")
      document.body.removeChild(textArea)
    }
  }
};
</script>

<style>
  @import "./../styles/consoleOutputComponent.css"
</style>
